<mat-card style="max-height: 900px; margin-top: 20px;">

    <mat-card-header style="margin-bottom: 20px">        
        <mat-card-title>RENDA FIXA</mat-card-title>
        <button 
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Adicionar Renda Fixa"
            (click)="openCadastro()"
        >
            <mat-icon>add</mat-icon>
        </button>
        
        <button 
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Gerar STVM PDF"
            (click)="gerarStvm()"
            *ngIf="length > 0"
        >
            <mat-icon>print</mat-icon>
        </button>
                
    </mat-card-header>

    <mat-card-content>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"
            [footerHeight]="50" 
            [rowHeight]="'auto'"
            [rows]='rows'
            [limit]="params.per_page"
            (sort)="onSort($event)">

            <ngx-datatable-column 
                name="Nome" 
                prop="produto" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-produto="value" 
                    ngx-datatable-cell-template
                >
                    {{produto.nome}}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column 
                name="Orgão Emissor" 
                prop="produto" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-row="row" 
                    ngx-datatable-cell-template
                >
                    {{ orgaoEmissor(row) }}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column 
                name="Valor" 
                prop="valor" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-valor="value" 
                    ngx-datatable-cell-template
                >
                    R$ {{valor | number : '1.2-2'}}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column 
                name="Quantidade" 
                prop="qtd" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-qtd="value" 
                    ngx-datatable-cell-template
                >
                    {{qtd | number : '1.0-0'}}
                </ng-template>

            </ngx-datatable-column> 

            <ngx-datatable-column 
                name="Data Inicio" 
                prop="data_operacao" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-data_operacao="value" 
                    ngx-datatable-cell-template
                >
                    {{data_operacao | date:'dd/MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column 
                name="Data Vencimento" 
                prop="produto" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-produto="value" 
                    ngx-datatable-cell-template
                >
                    {{produto.data_vencimento | date:'dd/MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column>  

            <ngx-datatable-column 
                name="Status" 
                prop="status_migracao" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-status_migracao="value" 
                    ngx-datatable-cell-template
                >
                    {{ status_migracao.nome }}
                </ng-template>
            </ngx-datatable-column>  

            <ngx-datatable-column 
                name="Verificado" 
                prop="verificado_migracao" 
                [sortable]="true"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-row="row" 
                    ngx-datatable-cell-template
                >
                    {{ getVerificado(row) }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Ação" 
                prop="id" 
                [sortable]="false" 
                [width]="160"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-id="value" 
                    ngx-datatable-cell-template
                >                     
                    <button 
                        mat-icon-button 
                        matTooltip="Alterar Renda Fixa" 
                        (click)="alterar(id)"
                    >
                        <mat-icon aria-label="Editar">edit</mat-icon>
                    </button>

                    <button
                        mat-icon-button
                        color="warn"
                        matTooltip="Excluir Renda Fixa"
                        (click)="delete(id)"
                    >
                        <mat-icon aria-label="Excluir Cliente">delete</mat-icon>
                    </button>

                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>  
        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"                
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>      
    </mat-card-content>
</mat-card>